import React, {Component} from 'react';
import ContextMenuView from "./ContextMenuView";


export default class ContextMenuContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            anchorEl: null,
            menuOptions: [],
            isButton: props.isButton ? props.isButton : false,
            label: props.label ? props.label : false,
            className: props.className ? props.className : false,
            icon: props.icon ? props.icon : false,
            iconPos: props.iconPos ? props.iconPos : false,
        };

    }

    /**
     * Función que guarda la opción de context menu que fue seleccionada
     * @param event
     */
    handleClick = event => {
        this.setState({
            anchorEl: event.currentTarget,
            menuOptions: this.props.menuOptions,
        });
    };

    /**
     * Función que cierra el context menu cuando se seleccionó alguna
     * de las opciones desplegadas
     */
    handleClose = () => {
        this.setState({anchorEl: null});
    }


    render() {
        const {
            anchorEl, menuOptions, isButton, label,
            className, icon, iconPos
        } = this.state;
        return (
            <ContextMenuView anchorEl={anchorEl}
                             menuOptions={menuOptions}
                             isButton={isButton}
                             label={label}
                             className={className}
                             icon={icon}
                             iconPos={iconPos}
                             handleClick={this.handleClick}
                             handleClose={this.handleClose}
            />
        );
    }
}
